import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'nh-my-documents',
    templateUrl: './my-documents.component.html',
    styleUrls: ['./my-documents.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class MyDocumentsComponent implements OnInit {

  constructor(private router: Router) { }
  ngOnInit(): void {
    sessionStorage.removeItem('submitSuccess');
  }

  goTo () {
    this.router.navigate(['/user-profile/my-documents', 'documents-we-need'])
  }

}
